import { AlertModal } from '@modusign/design-system';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { useMount } from 'react-use';

import LoadingStatus from '@libs/loading-status';

import RootLoadingSpinnerComponent from '@app/components/Loading/RootLoadingSpinnerComponent';
import embeddedService, { EmbeddedServiceError } from '@app/libs/embedded/embeddedService';
import redirect from '@app/libs/embedded/redirect';
import { logger } from '@app/libs/logger';
import { loadAccount } from '@app/store/account/actions';
import { getEmail, getUserLoadingStatus } from '@app/store/user/user/selectors';

export default function EmbeddedTemplate() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { templateId } = useParams<{ templateId: string }>();
  const email = useSelector(getEmail);
  const userLoadingStatus = useSelector(getUserLoadingStatus);

  const [error, setError] = useState<{ title: string; content: string } | null>(null);

  useMount(() => {
    if (!embeddedService.isEmbedded) {
      return;
    }

    switch (embeddedService.error) {
      case null:
        dispatch(loadAccount());
        break;
      case EmbeddedServiceError.EXPIRED_ACCESS_TOKEN:
        setError({
          title: '만료된 URL',
          content: 'URL이 만료되었습니다.\n다시 발급해 주세요.',
        });
        break;
      default:
        logger.error(`embedded service error occurred in embedded template page.`, {
          templateId,
          error: embeddedService.error,
        });
        setError({
          title: '유효하지 않은 접근',
          content: '유효하지 않은 접근입니다.',
        });
    }
  });

  useEffect(() => {
    if (userLoadingStatus === LoadingStatus.FAILED) {
      setError({
        title: '유효하지 않은 접근',
        content: '유효하지 않은 접근입니다.',
      });
      logger.error(`user load failed in embedded template page.`, { templateId });
    }
  }, [setError, templateId, userLoadingStatus]);

  useEffect(() => {
    if (email) {
      history.push(`/template/${templateId}/edit/participant-edit`);
    }
  }, [dispatch, email, history, templateId]);

  return (
    <div className="align-center">
      {error && (
        <AlertModal
          isOpen
          maxWidth="xxs"
          title={error.title}
          variant="warning"
          onClose={() => redirect('https://www.modusign.co.kr/')}
        >
          {error.content}
        </AlertModal>
      )}
      {userLoadingStatus === LoadingStatus.PENDING && (
        <RootLoadingSpinnerComponent isLoading isOverlay />
      )}
    </div>
  );
}
